export default __webpack_public_path__ + "static/media/layout-bg.3ea8779a.png";